module.exports = __webpack_public_path__ + "img/look5.5b785a28.png";